import { createStore as _createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import {
  aeroPhotoTourReducer,
  builderChatReducer,
  experimentsReducer,
  flatTourBookingScheduleReducer,
  flatViewOrderReducer,
  galleryMediaReducer,
  consultantChatReducer,
  newbuildingRecommendationsReducer,
  newbuildingReducer,
  noopReducer,
  offersReducer,
  openedPhonesReducer,
  realtyValuationReducer,
} from '../../reducers';
import { consultantCianChatReducer } from '../../reducers/consultantCianChat';
import { floorPlanReducer } from '../../reducers/floorPlanReducer';
import { promoInfoReducer } from '../../reducers/promoInfo';
import { userReducer } from '../../reducers/user';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, TReduxActions, TReduxStore } from '../../types/redux';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(initialState: IApplicationState, context: IApplicationContext, debugEnabled: boolean) {
  const reducers = combineReducers({
    aeroPhotoTour: aeroPhotoTourReducer,
    common: noopReducer(),
    experiments: experimentsReducer,
    flatTourBooking: flatTourBookingScheduleReducer,
    flatViewOrder: flatViewOrderReducer,
    galleryMedia: galleryMediaReducer,
    floorPlan: floorPlanReducer,
    newbuilding: newbuildingReducer,
    consultantChat: consultantChatReducer,
    newbuildingRecommendations: newbuildingRecommendationsReducer,
    offers: offersReducer,
    openedPhones: openedPhonesReducer,
    subdomain: noopReducer(),
    user: userReducer,
    promoInfo: promoInfoReducer,
    realtyValuation: realtyValuationReducer,
    isEcologyBlockEnabled: noopReducer(),
    reliability: noopReducer(),
    settings: noopReducer(),
    actualMortgageData: noopReducer(),
    builderChat: builderChatReducer,
    consultantCianChat: consultantCianChatReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const middlewares = [withExtraArgument(context)];

  const storeEnchancers = composeEnhancers(
    compose(applyMiddleware(...middlewares)),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions, IApplicationState, {}>(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
